import { useQuery } from "@tanstack/react-query";
import { fetchFundingWallets } from "@/api/campaignBuilder";

/** The campaign builder's funding-wallet options. Pass `enabled: false` on single-wallet plans. */
export function useFundingWallets(enabled: boolean) {
  return useQuery({
    queryKey: ["fundingWallets"],
    queryFn: fetchFundingWallets,
    enabled,
  });
}
